import { useTranslation } from "react-i18next";
import { Button, Col, ColorPicker, ColorPickerProps, Divider, Drawer, Form, Input, Modal, Radio, RadioChangeEvent, Row, Select, Space, Typography, Upload, UploadProps, message, theme } from 'antd'
import React, { useEffect, useState } from 'react'
import FormInput from '../../form-input/FormInput'
import FormRadio from '../../form-radio/FormRadio'
import { cyan, generate, green, presetPalettes, red } from '@ant-design/colors';
import { CloseOutlined, CopyOutlined, ExclamationCircleOutlined, HeatMapOutlined, InfoCircleOutlined, LoadingOutlined, PicCenterOutlined, PlayCircleOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons'
import FormItemDropdown from '../../form-dropdown/FormItemDropdown'
// import "./index.scss"
import CommonModal from '../../modal/common'
import { useLocation, useNavigate } from 'react-router-dom'
import { FileType } from '../../../utils/uploadImage'
import { createPortalAdministration, getAllUniversity } from '../../../service/portal-administration';
import { isEmpty } from 'lodash';
import ReactQuill from 'react-quill';
import { FORMAT_REACT_QUILL, TOOLBAROPTIONS } from '../../../constants';
import { publishCourse } from '../../../service/course-construct';
import { createContentForum, createTopic, getListContentForTopic, updateContentForum, updateTopic } from '../../../service/blog-and-forum';
var indexDB = require("idbcache").default;

type Props = {
  open: boolean
  handleClose: () => void
  getListData: () => void
  id: string | undefined
  dataUpdate?: any
  mode?: any
}

type Presets = Required<ColorPickerProps>['presets'][number];

const genPresets = (presets = presetPalettes) =>
  Object.entries(presets).map<Presets>(([label, colors]) => ({
    label,
    colors,
  }));

const getBase64 = (img: FileType, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

const beforeUpload = (file: FileType) => {
  // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  // if (!isJpgOrPng) {
  //   message.error('You can only upload JPG/PNG file!');
  // }
  // // const isLt2M = file.size / 1024 / 1024 < 2;
  // // if (!isLt2M) {
  // //   message.error('Image must smaller than 2MB!');
  // // }
  // // return isJpgOrPng && isLt2M;
  return false
}

export default function AddContentForumDrawer(props: Props) {
  const { t } = useTranslation();
  const { open, handleClose, getListData, dataUpdate, mode } = props
  const [form] = Form.useForm();
  const [value, setValue] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [listContentForTopic, setListContentForTopic] = useState<any>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>();
  const [color, setColor] = React.useState<string>('#1677ff');
  // const [value, setValue] = useState("");

  const validation = {
    titleBlog: {
      required: true,
      validator: (_: any, value: any) => {
        if (value.replace(/<p><br><\/p>/g, "") !== "") {
          return Promise.resolve();
        } else {
          return Promise.reject('Some message here');
        }
      },
      message: t("Vui lòng nhập tiêu đề blog", "Vui lòng nhập tiêu đề blog")
    },
    postForTopic: {
      required: true,
      message: t("Vui lòng chọn bài đăng cho chủ đề", "Vui lòng chọn bài đăng cho chủ đề")
    },
    descriptionBlog: {
      required: true,
      validator: (_: any, value: any) => {
        if (value.replace(/<p><br><\/p>/g, "") !== "") {
          return Promise.resolve();
        } else {
          return Promise.reject('Some message here');
        }
      },
      message: t("Vui lòng nhập mô tả blog", "Vui lòng nhập mô tả blog")
    },
  }

  const dataStatus = [
    {
      value: true,
      label: t("Hoạt động", "Hoạt động")
    },
    {
      value: false,
      label: t("Không hoạt động", "Không hoạt động")
    }
  ]

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
  };

  const OPTIONS = [
    {
      value: 1,
      label: <PlayCircleOutlined />
    },
    {
      value: 2,
      label: <PicCenterOutlined />
    },
    {
      value: 3,
      label: <CopyOutlined />
    },
    {
      value: 4,
      label: <HeatMapOutlined />
    }
  ];

  const listVideo = [
    {
      id: 4,
      name: t("Mẫu đánh giá 1", "Mẫu đánh giá 1")
    },
    {
      id: 5,
      name: t("Mẫu đánh giá 2", "Mẫu đánh giá 2")
    },
    {
      id: 6,
      name: t("Mẫu đánh giá 3", "Mẫu đánh giá 3")
    }
  ]

  const gotoAddLessonPage = () => {
    form.submit()
  }

  const handleChange: UploadProps['onChange'] = (info) => {
    setLoading(true);
    getBase64(info.fileList?.[0]?.originFileObj as FileType, (url) => {
      setLoading(false);
      setImageUrl(url);
    });
    // }
  };

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const modules = {
    toolbar: TOOLBAROPTIONS,
    clipboard: {
      matchVisual: false,
    }
  };

  const resetData = () => {
    getListData()
    handleClose()
    form.resetFields()
    setImageUrl("")
  }

  const saveData = async (values: any) => {
    let data = {}
    if (dataUpdate?.id) {
      data = {
        id: dataUpdate?.id,
        name: values.titleBlog.replaceAll(/<\/?p[^>]*>/g, '').replace('<br>', ''),
        description: values.descriptionBlog.replaceAll(/<\/?p[^>]*>/g, '').replace('<br>', ''),
        status: dataUpdate.status,
        blogId: values.postForTopic ?? 0
      }
      await updateTopic(data).then(res => {
        if (res.status === 200) {
          message.success(t("Sửa thông tin thành công", "Sửa thông tin thành công"))
          resetData()
          handleClose()
        }
      })
    } else {
      data = {
        name: values.titleBlog.replaceAll(/<\/?p[^>]*>/g, '').replace('<br>', ''),
        description: values.descriptionBlog.replaceAll(/<\/?p[^>]*>/g, '').replace('<br>', ''),
        status: 1,
        blogId: values.postForTopic ?? 0
      }
      await createTopic(data).then(res => {
        if (res.status === 200) {
          message.success(t("Lưu thông tin thành công", "Lưu thông tin thành công"))
          resetData()
          handleClose()
        }
      })
    }
  }

  const getListTopic = async () => {
    await getListContentForTopic().then((res) => {
      setListContentForTopic(res.data.data)
    })
  }

  useEffect(() => {
    if (open) {
      getListTopic()
    }
  }, [open])

  useEffect(() => {
    if (dataUpdate) {
      form.setFieldValue("titleBlog", dataUpdate?.name ?? '')
      form.setFieldValue("postForTopic", dataUpdate?.blogId ?? '')
      form.setFieldValue("descriptionBlog", dataUpdate?.description ?? '')
      setImageUrl(dataUpdate?.imagePath)
    }
  }, [dataUpdate])

  return (
    <Form.Provider onFormFinish={async (name, { values, forms }) => {
      if (name === 'form-add-blog-content') {
        Modal.confirm({
          title: t("Xác nhận lưu chủ đề", "Xác nhận lưu chủ đề"),
          content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu chủ đề.", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu chủ đề."),
          onOk: () => {
            saveData(values)
          },
          okText: t("Xác nhận", "Xác nhận"),
          cancelText: t("Huỷ", "Huỷ"),
          centered: true,
          icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
          footer: (_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          ),
        });
      }
    }}>

      <Drawer
        title={dataUpdate?.id ? t("Sửa chủ đề", "Sửa chủ đề") : t("Thêm chủ đề", "Thêm chủ đề")}
        placement={"right"}
        className='add-blog-content-drawer'
        width={600}
        onClose={handleClose}
        open={open}
        extra={
          <Space>
            {
              mode !== 'view' ?
                <>
                  <Button onClick={handleClose} className="btn btn-outlined">
                    <CloseOutlined />
                    <Typography.Text>
                      {t("Hủy", "Hủy")}
                    </Typography.Text>
                  </Button><Button className="btn btn-primary"
                    onClick={() => form.submit()}>
                    <SaveOutlined />
                    <Typography.Text>
                      {t("Lưu", "Lưu")}
                    </Typography.Text>
                  </Button>
                </> : null
            }
          </Space>
        }
      >
        <>
          <Form layout={"vertical"} form={form} name="form-add-blog-content">
            <Row gutter={24}>
              <Col span={24} className=''>
                <Typography.Title level={5}>{t("Bài đăng", "Bài đăng")} <span className='span-red'>*</span></Typography.Title>
                <p className='text-secondary'>{t("Chọn bài đăng cho chủ đề", "Chọn bài đăng cho chủ đề")}</p>
                <Form.Item name="postForTopic" rules={[validation.postForTopic]} label="" hasFeedback>
                  {/* <FormItemDropdown placeholder={t("Chọn bài đăng", "Chọn bài đăng")} disabled={mode === 'view'}
                    options={listContentForTopic} /> */}
                    <Select placeholder={t("Chọn bài đăng", "Chọn bài đăng")} disabled={mode === 'view'}>
                      {listContentForTopic.map((item: any) => (
                        <Select.Option value={item?.id}><div contentEditable='true' dangerouslySetInnerHTML={{ __html: item?.name }}></div></Select.Option>
                      ))}
                    </Select>
                </Form.Item>
              </Col>
              <Col span={24} className='mt-2'>
                <Typography.Title level={5}>{t("Tiêu đề của chủ đề", "Tiêu đề của chủ đề")} <span className='span-red'>*</span></Typography.Title>
                <p className='text-secondary'>{t("Nhập tiêu đề cho chủ đề của bạn", "Nhập tiêu đề cho chủ đề của bạn")}</p>
                <Form.Item name="titleBlog" rules={[validation.titleBlog]} label="">
                  <ReactQuill
                    className='mt-1'
                    modules={modules}
                    formats={FORMAT_REACT_QUILL}
                    theme="snow"
                    readOnly={mode === 'view'}
                    placeholder={t("Nhập text", "Nhập text")} />
                </Form.Item>
              </Col>
              <Col span={24} className='mt-2'>
                <Typography.Title level={5}>{t("Mô tả", "Mô tả")} <span className='span-red'>*</span></Typography.Title>
                <p className='text-secondary'>{t("Nhập mô tả cho chủ đề của bạn", "Nhập mô tả cho chủ đề của bạn")}</p>
                <Form.Item name="descriptionBlog" rules={[validation.descriptionBlog]} label="">
                  <ReactQuill
                    className='mt-1'
                    modules={modules}
                    formats={FORMAT_REACT_QUILL}
                    theme="snow"
                    readOnly={mode === 'view'}
                    // onChange={setValue}
                    placeholder={t("Nhập text", "Nhập text")} />
                </Form.Item>
              </Col>

              <Col span={24} className='flex mt-2 gap-6'>
                <Typography.Title level={5}>{t("Trạng thái", "Trạng thái")} <span className='span-red'>*</span></Typography.Title>
                <div className="radio-group-list">
                  <div className="wrapper-radio">
                    <Radio checked>{t("Nháp", "Nháp")}</Radio>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </>
      </Drawer>
    </Form.Provider >
  )
}
